import { Permissions } from '@cloud-wave/neon-common-lib';

import { LogEvents, logger } from 'lib/common/components/LoggerController';

import CONTACT_STATES from 'lib/common/constants/contactStates';

import { usePermissionsContext } from '../../PermissionsContext';
import THandleContactChange from '../types/HandleContactChange';
import useClearContact from './useClearContact';

type THandleMissedArgs = {
  handleContactChange: THandleContactChange;
};

export default function useMissedContact({ handleContactChange }: THandleMissedArgs) {
  const { hasPermission } = usePermissionsContext();
  const clearContact = useClearContact({ handleContactChange });

  const hasMissedCallPermission = hasPermission({
    type: 'tenant',
    permission: Permissions.AGENT_MISSED_CALL,
  });

  return async (contact?: connect.Contact) => {
    if (!hasMissedCallPermission) {
      return clearContact(contact);
    }

    logger.info(LogEvents.TASK.MISSED, { contact });

    handleContactChange({ contact, status: CONTACT_STATES.MISSED });
  };
}
